import { configureStore } from "@reduxjs/toolkit"
import rootReducer from '../reducers/rootReducer'

const getStore = () => {
  const preloadedState = {};  //todo kh think about how to use it

  return configureStore({
    reducer: rootReducer(),
    devTools: process.env.NODE_ENV === 'development',
    preloadedState
  });
}


const store = getStore();

export default store;